// extracted by mini-css-extract-plugin
export var bold = "_yk-0";